import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import './Loading.scss'

class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {
          large: false,
          submitButtons:true,
          loadingButton:true
        };
        this.toggleLarge = this.toggleLarge.bind(this);
    }
    toggleLarge() {
        this.setState({
        large: !this.state.large,
        });
    }
  render() {
    return (
        <div>
            <Modal isOpen={this.props.loadingStatus} toggle={this.toggleLarge} centered className={'modal-lg ' + this.props.className + ' loading-model'}>
            <div className="loader">
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                    <span className="loader-item"></span>
                </div>
            </Modal>
        </div>
    );
  }
}

export default Loading
